// src/data/capabilitiesData.js

export const pillarsData = [
  {
    id: 'genai',
    icon: 'Brain',
    label: 'AI AGENTS · COPILOTS',
    title: 'GenAI Solutions & Copilots',
    subline: 'AI Agents · Copilots',
    bullets: [
      'Planning & scheduling copilots for operations leadership',
      'Document intelligence: search, summarization, Q&A over SOPs',
      'Troubleshooting assistants combining data with domain logic',
      'Real-time operational intelligence from process logs and sensors'
    ],
    tags: ['GenAI', 'Agents', 'Knowledge Search', 'RAG'],
    bulletIcons: ['Calendar', 'FileText', 'Wrench', 'Zap'],
    accent: '#8B5CF6', // Violet
    image: '/assets/our_capabilities/img1.webp',
    imagePosition: 'right',
    // Vibrant card styling
    cardGradient: 'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 50%, #C4B5FD 100%)',
    cardTextColor: '#FFFFFF',
    cardLabelBg: 'rgba(255, 255, 255, 0.2)',
    tagStyle: { bg: 'rgba(255, 255, 255, 0.2)', text: '#FFFFFF', border: 'rgba(255, 255, 255, 0.3)' }
  },
  {
    id: 'analytics',
    icon: 'BarChart3',
    label: 'OPERATIONS · MANUFACTURING',
    title: 'Advanced Manufacturing Analytics',
    subline: 'Operations · Manufacturing',
    bullets: [
      'Real-time OEE, scrap & downtime tracking',
      'Causal models to find true root causes',
      'Predictive maintenance for equipment reliability',
      'Anomaly detection & proactive alerts'
    ],
    tags: ['OEE', 'Root Cause', 'Predictive', 'IoT'],
    bulletIcons: ['Activity', 'Search', 'Settings', 'AlertCircle'],
    accent: '#F59E0B', // Amber/Gold
    image: '/assets/our_capabilities/img2.webp',
    imagePosition: 'left',
    // Vibrant card styling - Golden/Amber
    cardGradient: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 50%, #FCD34D 100%)',
    cardTextColor: '#1F2937',
    cardLabelBg: 'rgba(0, 0, 0, 0.1)',
    tagStyle: { bg: 'rgba(0, 0, 0, 0.1)', text: '#1F2937', border: 'rgba(0, 0, 0, 0.2)' }
  },
  {
    id: 'platforms',
    icon: 'Code2',
    label: 'PRODUCT ENGINEERING',
    title: 'Custom Applications & Platforms',
    subline: 'Product Engineering',
    bullets: [
      'Modern React & Next.js frontends',
      'Cloud-native on Azure, AWS or GCP',
      'Secure Node.js & Python backends',
      'AI & analytics layer integration'
    ],
    tags: ['React', 'Python', 'Azure', 'Databricks', 'Snowflake'],
    bulletIcons: ['Layout', 'Cloud', 'Shield', 'Layers'],
    accent: '#10B981', // Emerald/Mint
    image: '/assets/our_capabilities/img3.webp',
    imagePosition: 'right',
    // Vibrant card styling - Mint/Green
    cardGradient: 'linear-gradient(135deg, #10B981 0%, #34D399 50%, #6EE7B7 100%)',
    cardTextColor: '#FFFFFF',
    cardLabelBg: 'rgba(255, 255, 255, 0.2)',
    tagStyle: { bg: 'rgba(255, 255, 255, 0.2)', text: '#FFFFFF', border: 'rgba(255, 255, 255, 0.3)' }
  }
];
